import React from "react";
import DataGrid from './data-grid';
import { Tooltip } from '@progress/kendo-react-tooltip';
import format from "../functions/format";
import Trend from "./trend";
export default class ActivityPagesLocationGrid extends React.Component {
  render() {
    var data = this.props.data;
    var domain = this.props.domain;
    var column = this.props.column;
    var comparison = this.props.comparison;
    var columns = [{
      field: 'url',
      title: 'Url',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var url = row.url;
        if (!url.includes(domain)) url = domain + url;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Tooltip, {
          anchorElement: "target",
          position: "top"
        }, /*#__PURE__*/React.createElement("a", {
          href: url,
          target: "_blank",
          title: row.url
        }, row.url)));
      }
    }, {
      field: 'title',
      title: 'Title',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Tooltip, {
          anchorElement: "target",
          position: "top"
        }, /*#__PURE__*/React.createElement("span", {
          title: format(row.title, '-', 0, '')
        }, format(row.title, '-', 0, ''))));
      }
    }, {
      field: 'city',
      title: 'City',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.city));
      }
    }, {
      field: 'postalCode',
      title: 'Postal Code',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.postalCode));
      }
    }, {
      field: 'regionCode',
      title: 'Region',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.regionCode));
      }
    }, {
      field: 'views',
      title: 'Views',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.views, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.views,
          data: row.views
        })));
      }
    }, {
      field: 'uniqueUsers',
      title: 'Unique Users',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.uniqueUsers, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.uniqueUsers,
          data: row.uniqueUsers
        })));
      }
    }, {
      field: 'sessions',
      title: 'Sessions',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.sessions, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.sessions,
          data: row.sessions
        })));
      }
    }, {
      field: 'avgTimeSpan',
      title: 'Avg Time Span',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var avgTimeSpan = row.avgTimeSpan;
        if (typeof avgTimeSpan === 'object') {
          avgTimeSpan = JSON.stringify(avgTimeSpan);
        }
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(avgTimeSpan, '-', 2, '')));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}